import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AppErrors, ConflictError, NotFoundError } from '@fitness-force/models';;
import type { CreateWhatsAppSenderConfigurationRequest, ListWhatsAppSenderConfigurationMasterResponse, WhatsAppSenderConfigurationMasterResponse } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { map, catchError, throwError, Observable } from 'rxjs';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root'
})
export class CustomAudienceConfigService {
  private http = inject(HttpClient);

  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };


  GetCustomAudienceConfig(tenantId: number,configId: number): Observable<WhatsAppSenderConfigurationMasterResponse> {
    return this.http.get<WhatsAppSenderConfigurationMasterResponse>(
        environment.BASE_URL + CONST_URL_SEGEMENTS.FACEBOOK_CUSTOM_AUDIENCE.GET_CUSTOM_AUDIENCE_BY_ID
          .replace('{tenant_id}', tenantId.toString())
          .replace('{config_id}', configId.toString()),
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  CreateCustomAudienceConfig(tenantId: number,payload: any) {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.FACEBOOK_CUSTOM_AUDIENCE.CREATE_CUSTOM_AUDIENCE
      .replace('{tenant_id}', tenantId.toString()),payload,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  ListCustomAudienceConfig(tenantId: number): Observable<any> {
    return this.http.get<ListWhatsAppSenderConfigurationMasterResponse>(
        environment.BASE_URL + CONST_URL_SEGEMENTS.FACEBOOK_CUSTOM_AUDIENCE.GET_CUSTOM_AUDIENCES
          .replace('{tenant_id}', tenantId.toString()),
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  UpdateCustomAudienceConfig(tenantId: number,configId: number,payload: any) {
    return this.http.put(environment.BASE_URL + CONST_URL_SEGEMENTS.FACEBOOK_CUSTOM_AUDIENCE.UPDATE_CUSTOM_AUDIENCE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{config_id}', configId.toString()),payload,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  ActiveCustomAudienceConfig(tenantId: number,configId: number) {
    return this.http.put(environment.BASE_URL + CONST_URL_SEGEMENTS.FACEBOOK_CUSTOM_AUDIENCE.ACTIVE_CUSTOM_AUDIENCE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{config_id}', configId.toString()),this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  InActiveCustomAudienceConfig(tenantId: number,configId: number) {
    return this.http.put(environment.BASE_URL + CONST_URL_SEGEMENTS.FACEBOOK_CUSTOM_AUDIENCE.INACTIVE_CUSTOM_AUDIENCE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{config_id}', configId.toString()),this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  
}
